const useLocalDateTime = (locale: string) => {

    const getTimeString = (date?: Date | string) => {
        if (!date) {
            return "";
        }

        return new Date(date).toLocaleTimeString(locale, { timeStyle: "short" });
    }

    const getDateString = (date?: Date | string, hideCurrentYear = false) => {
        if (!date) {
            return "";
        }

        const d = new Date(date);

        const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };

        if (!hideCurrentYear) {
            return d.toLocaleDateString(locale, dateOptions);
        }

        const currentYear = new Date().getFullYear();

        if (d.getFullYear() === currentYear) {
            delete dateOptions.year;
        }

        return d.toLocaleDateString(locale, dateOptions);
    }

    return [getTimeString, getDateString];
}

export default useLocalDateTime;